import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import AccountDetails from "./AccountDetails/AccountDetails";
import RoleDetails from "./RoleDetails/RoleDetails";
import BotDetails from "./BotDetails/BotDetails";
import './UserDetails.css'

const useStyles = makeStyles({
    container: {
        width: "100%",
        height: "100%",
    },
    item: {
        width: "100%",
    },
    accountDetail: {},
});

function UserDetails() {
    const classes = useStyles();
    const [roles, setRoles] = useState();
    const [user, setUser] = useState();

    return (
        <Grid
            container
            spacing={5}
            className={classes.container}
            direction="row"
            data-test="userDetail-page"
        >
            <Grid item xs={12} lg={6}>
                <AccountDetails setRoles={setRoles} setUser={setUser} />
            </Grid>

            {/* <Divider orientation='vertical'/> */}
            <Grid item xs={12} lg={6}>
                <RoleDetails roles={roles} setRoles={setRoles} user={user} />
            </Grid>
            <Grid item xs={12} lg={6} style={{ marginTop: 30 }}>
                <BotDetails />
            </Grid>
        </Grid>
    );
}

export default UserDetails;
